import ImageService from '@/services/ImageService'
import GLTFService from '@/services/GLTFService'
import ResizeService from 'src/services/ResizeService'  

import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'

import { clamp, map, DEG_TO_RAD, randomInRange, randomDist } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'

import BaseGroup from '@/components/stage/common/base_group'

import gsap from 'gsap'
import dat from 'dat.gui'

const THREE = require('three') 

const Events = {}

const CONST = {
  BASE_WIDTH: 580
}

const STATES = {
  OPENING: 'STATE:OPENING',
  OPEN: 'STATE:OPEN',
  CLOSED: 'STATE:CLOSED',
  CLOSING: 'STATE:CLOSING'
}

class Bubble extends BaseGroup {

  constructor(config) {

    super(config)

    this.Events = Events
    Object.assign(this, EventEmitter)

    this.options = {
      strength: 0.25
    } 

    this.setup()
    this.resize() 
    this.position.z = 1

  }

  setup() {

    this.frame = 0
    this._position = new THREE.Vector3(0, 0, 0)  
    this.state = null

    this.tweenObj= {
      curveMix: 1
    }
 
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        // uTexture: {
        //   value: null
        // },
        uOffset: {
          value: new THREE.Vector2(0.0, 0.0)
        },
        uAlpha: {
          value: 1
        },
        density: {
          value: 2.5
        },
        time: {
          value: 2.5
        },
        curveMix: {
          value:  this.tweenObj.curveMix
        },
        amplitude: {
          value:  Env.mobile ? 0 : 0.01
        } 
      },
      vertexShader: `
        uniform vec2 uOffset;
        uniform float density;
        uniform float amplitude;
        uniform float time; 
        uniform float curveMix; 
 
        void main() { 
          vec3 newPosition = position;

          float M_PI = 3.1415926535897932384626433832795;
          float speed = time * 0.55;
          float uvy = (uv.y * density) - speed;
          float wave = sin(uvy) * cos(time) * sin(time);
          float positionA = newPosition.x + (wave * amplitude); 
          float positionB = newPosition.x - (sin(uv.y * M_PI) * 0.25  );
          newPosition.x = mix(positionA , positionB , curveMix); 

          gl_Position = projectionMatrix * modelViewMatrix * vec4( newPosition, 1.0 );
        }
      `,
      fragmentShader: ` 
        uniform float uAlpha;
 
        vec2 scaleUV(vec2 uv,float scale) {
          float center = 0.5;
          return ((uv - center) * scale) + center;
        }

        void main() {
          //vec3 color = vec3(1. ,0. ,0.);
          gl_FragColor = vec4(vec3(1. ,1. ,1.), 1.);
        }
      `,
      transparent: true
    })

    this.plane = new THREE.Mesh( new THREE.PlaneBufferGeometry(1, 1, 1, 50) , /*new THREE.MeshBasicMaterial({color: 0xFFFFFF})*/ this.material)
    this.plane.position.z = -0.1   
    this.plane.scale.x = window.innerWidth
    this.plane.position.x = -window.innerWidth
    this.plane.scale.y = window.innerHeight
    this.add(this.plane)
    this.visible = false 
  }

  setState(state){
    this.state = state
  }

  addGUI() {}

  updateGUI () {}

  updateMaterial(){
    if(this.material && ( this.state === STATES.OPEN || this.state === STATES.CLOSING )){ 
      this.material.uniforms.time.value = this.frame //time * 0.001
      this.material.uniforms.curveMix.value = this.tweenObj.curveMix
    }
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }

  pointerMove(event){ }

  pointerStart(event){ }

  pointerEnd(event){ }

  killTweens(){ 
    gsap.killTweensOf([this.plane.position, this.tweenObj, this.onLeaveComplete])
  }



  // UPDATES -------------------------------------------------------------------


  tick( dt, time ) { 
    this.frame += 0.01 // time * 0.001
    this.updateMaterial()
  }

  resize() {

    let ww = window.innerWidth
    let wh = window.innerHeight
    this.plane.scale.y = wh
    this.plane.scale.x = ww

    if(this.state === STATES.OPEN){ 
      this.enter(0,0)
    } else {
      this.leave(0)
    }
  }

  destroy(){}
 
  enter(duration = 2, delay = 0){ 

    this.visible = true
    this.setState(STATES.OPEN)
    this.killTweens()
    
    let ww = window.innerWidth  
    let tgx = Env.mobile ? 0 : ((ResizeService.scale * CONST.BASE_WIDTH) - ww)
    this.plane.scale.x = window.innerWidth  
    
    gsap.to(this.plane.position, {
      delay: this.getDuration(delay), 
      duration: this.getDuration(duration), 
      x: tgx,  
      ease: 'elastic.out(0.25)', 
      onUpdate: this.onUpdate 
    })
    
    gsap.to(this.tweenObj, { 
      curveMix: 0, 
      duration: this.getDuration(duration), 
      delay: this.getDuration(delay), 
      ease: 'elastic.out(0.5)' 
    }) 
  }

  leave(duration = 1 ){

    this.setState(STATES.CLOSING) 
    this.killTweens()

    gsap.to(this.plane.position, {
      duration: this.getDuration(duration), 
      x: -window.innerWidth, 
      ease: 'power3.inOut', 
      onUpdate: this.onUpdate 
    })

    gsap.to(this.tweenObj, { 
      duration: this.getDuration(duration),
      curveMix: 1, 
      ease: 'back.in(2)', 
      onComplete: this.onLeaveComplete 
    }) 
  }

  onLeaveComplete = () => {
    this.visible = false 
    this.setState(STATES.CLOSED)
  }

  onUpdate = () =>  {
    // let offset = this.plane.position
    //   .clone()
    //   .sub(this._position)
    //   .multiplyScalar(-this.options.strength)
    // this.material.uniforms.uOffset.value = offset
  }



  // HANDLERS -------------------------------------------------------------------



  // STATES -------------------------------------------------------------------

  /* modal states */

  modalMenu(){ 
    this.enter() 
  }

  modalNone(){ 
    this.leave() 
  }

  
  // routes

  routeLoading(){ }
  
  // routeHome(){ this.leave() }

  // routeOneStar(){ this.enter() }
  // routeTwoStar(){ this.enter() }
  // routeThreeStar(){ this.enter() }
  // routeFourStar(){ this.enter() }
  // routeFiveStar(){ this.enter() }
 

  /* home states */

  welcome(val, prev){ }

  ratingFive(val, prev){ }

  ratingFour(val, prev){ }

  ratingThree(val, prev){ }

  ratingTwo(val, prev){ }

  ratingOne(val, prev){ }

  cta(val, prev){ }

}


export default Bubble 